import mixpanel from "mixpanel-browser";
import { config } from "./config";

export const initializeAnalytics = () => {
  console.log("📊 Initializing analytics...");
  
  // Attempt to initialize Mixpanel.
  // This may get blocked by ad blocker or other privacy-focused extensions.
  if (config.mixpanel.token) {
    console.log("🔧 Mixpanel config:", {
      token: config.mixpanel.token?.substring(0, 8) + "...",
      persistence: config.mixpanel.persistence,
      recordSessionsPercent: config.mixpanel.recordSessionsPercent
    });
    
    try {
      mixpanel.init(config.mixpanel.token, {
        autotrack: false,
        persistence: config.mixpanel.persistence,
        track_pageview: false,
        record_sessions_percent: config.mixpanel.recordSessionsPercent,
      });
      console.log("✅ Mixpanel initialized successfully");
    } catch (error) {
      console.error("❌ Mixpanel initialization failed:", error);
    }
  } else {
    console.warn("⚠️ Mixpanel token not configured, analytics disabled");
  }
};
